import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/lib/supabase';

interface AppointmentData {
  id: string;
  start_time: string;
  end_time: string;
  status: string;
}

export default function AppointmentBadge() {
  const { user } = useAuth();
  const [appointment, setAppointment] = useState<AppointmentData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setLoading(false);
      return;
    }

    const fetchAppointment = async () => {
      try {
        const now = new Date().toISOString().split('T')[0] + ' 00:00:00';
        const { data, error } = await supabase
          .from('appointments')
          .select('id, start_time, end_time, status')
          .eq('user_id', user.id)
          .eq('status', 'confirmed')
          .gte('start_time', now)
          .order('start_time', { ascending: true })
          .limit(1)
          .maybeSingle();

        if (error) throw error;
        setAppointment(data as AppointmentData | null);
      } catch {
        setAppointment(null);
      } finally {
        setLoading(false);
      }
    };

    fetchAppointment();
  }, [user]);

  if (loading || !appointment) return null;

  const formatDate = (datetime: string): string => {
    const [datePart, timePart] = datetime.split(' ');
    const [y, m, d] = datePart.split('-');
    const time = timePart ? timePart.substring(0, 5) : '';
    return `${d}/${m}/${y} às ${time}`;
  };

  return (
    <div className="bg-emerald-50 dark:bg-emerald-500/5 border border-emerald-200 dark:border-emerald-500/15 rounded-xl p-4 flex items-center gap-4 animate-fadeIn">
      <div className="w-10 h-10 rounded-xl bg-emerald-100 dark:bg-emerald-500/15 flex items-center justify-center flex-shrink-0">
        <i className="ri-calendar-check-line text-xl text-emerald-600 dark:text-emerald-400" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-emerald-800 dark:text-emerald-300">
          Implantação agendada!
        </p>
        <p className="text-xs text-emerald-600 dark:text-emerald-400 mt-0.5">
          {formatDate(appointment.start_time)} — {formatDate(appointment.end_time).split(' às ')[1] || ''}
        </p>
      </div>
      <Link
        to="/setup-fee"
        className="flex-shrink-0 px-3 py-1.5 bg-emerald-100 dark:bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 text-xs font-medium rounded-lg hover:bg-emerald-200 dark:hover:bg-emerald-500/20 transition-colors whitespace-nowrap"
      >
        Ver detalhes
      </Link>
    </div>
  );
}